(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/routers/AppRouter',["jquery", "backbone", "pricelist/models/PriceList", "pricelist/views/AppView"], function($, Backbone, PriceList, AppView) {
    var Router;
    return Router = (function(superClass) {
      extend(Router, superClass);

      function Router() {
        return Router.__super__.constructor.apply(this, arguments);
      }

      Router.prototype.initialize = function() {
        this.priceList = new PriceList;
        this.appView = new AppView({
          priceList: this.priceList
        });
        return Backbone.history.start();
      };

      Router.prototype.routes = {
        "": "home",
        ":id/:layout": "specific"
      };

      Router.prototype.home = function() {
        this.priceList.set({
          id: $("#select-priceList").val()
        });
        return this.appView.render();
      };

      Router.prototype.specific = function(id, layout) {
        this.priceList.set({
          id: id
        });
        this.priceList.layout(layout);
        return this.appView.render();
      };

      return Router;

    })(Backbone.Router);
  });

}).call(this);

//# sourceMappingURL=AppRouter.js.map
;
